import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="container-x flex min-h-[80vh] flex-col items-center justify-center text-center" data-testid="not-found">
      <span className="font-display text-8xl font-semibold text-gold">404</span>
      <h1 className="mt-4 font-display text-3xl font-semibold text-navy">{t.notFound.title}</h1>
      <p className="mt-3 max-w-sm text-muted">{t.notFound.sub}</p>
      <Link to="/" className="btn-primary mt-8">{t.notFound.btn}</Link>
    </div>
  );
}
